import React from 'react'
import { Link } from "react-router-dom";

function Footer() {
  return (
     <>
      {/* <!-- Footer Start --> */}
   <div className="container-fluid bg-dark text-secondary footer mt-5   wow fadeIn" data-wow-delay="0.1s">
  <div className="container py-3">
    <div className="row g-2">
      <div className="col-lg-3 col-md-6">
        <h5 className="text-primary mb-4" style={{color: '#1432a5'}}>Address</h5>
        <p className="mb-0"><i className="fa fa-map-marker-alt me-3" style={{color: '#1432a5'}} />Ashok Nagar, Road No-7B, Kankarbagh, Near Ramdev Mandir, Patna</p>
         <p className="mb-2"><i className="fa fa-phone-alt me-3" style={{color: '#1432a5'}} />+91 97988 15360</p>
        <p className="mb-2"><i className="fa fa-envelope me-3" style={{color: '#1432a5'}}/>eagle.eye112002@gmail.com</p>
         
      </div>
      <div className="col-lg-3 col-md-6">
        <h5 className="text-primary mb-4">Services</h5>
        <Link className="btn btn-link"  >Camera Intercom</Link>
        <Link className="btn btn-link"  >Home/Office Security</Link>
        <Link className="btn btn-link"  >GPS</Link>
        <Link className="btn btn-link"  >Biometric Sensor</Link>
        <Link className="btn btn-link"  >Commercial CCTV System</Link>
      </div>
      <div className="col-lg-3 col-md-6">
        <h5 className="text-primary mb-4">Quick Links</h5>
        <Link className="btn btn-link"  to="/">Home</Link>
        <Link className="btn btn-link"  to="/about">About Us</Link> 
        <Link className="btn btn-link"  to="service">Our Services</Link>
        <Link className="btn btn-link"  to="/contact">Contact Us</Link>
               </div>
      <div className="col-lg-3 col-md-6">
        <h5 className="text-primary mb-4">Location</h5> 
        <div className="position-relative"> 
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3598.5183964325715!2d85.15001257366843!3d25.587684865982588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed5883eda5e639%3A0xc4ae30fc90ba2d27!2s7%2C%20Main%20Ashok%20Nagar%20Rd%2C%20Kankarbagh%2C%20Patna%2C%20Bihar%20800020!5e0!3m2!1sen!2sin!4v1697356286768!5m2!1sen!2sin"   width={334} height={200} style={{border: "0"}}    title='map' loading="lazy"></iframe>

        </div> 

        
      </div>
    </div>
  </div>
</div>

    {/* <!-- Footer End --> */}


    {/* <!-- Copyright Start --> */}
   <div className="container-fluid py-2" style={{background: '#000000'}}>
  <div className="container">
    <div className="row">
      <div className="col-md-6 text-center text-md-start mb-1 mb-md-0">
        ©<Link to="">eagleeyeenterprises</Link> All Right Reserved.
      </div>
      <div className="col-md-6 text-center text-md-end"> 
        Designed By <Link>neetu kumari</Link>
      </div>
    </div>
  </div>
</div>
    {/* <!-- Copyright End --> */}

     </>
  )
}

export default Footer